import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './basicArchives.module.scss';
import  { ApiCore } from '../../../api/index';
import patient_home_avatar from '../../../static/images_doctor/patient_home_avatar.png';
import patient_home_avatar_bg from '../../../static/images_doctor/patient_home_avatar_bg.png';
import followup_node_icon from '../../../static/images_doctor/followup_node_icon.png';
import right_arrow from '../../../static/images/rightArrow.png';
import utils from '../../../utils/utils';
import PatientHomeDetail from './patientHomeDetail';
import { Tabs, Toast } from 'antd-mobile';
import CRFComponent from '../../../component/crf/crf';

const api = new ApiCore();

function InformedArchives(props: any) {

    const [imgList, setImgList] = useState([]);
    const [formData, setFormData] = useState<any>({});

    const CrfRef: any = useRef();

    const history = useHistory();

    useEffect(() => {
        initData();
        return () => {
        }
    }, [props.allData])

    const initData = () => {
        let _param = props.allData || {};
        if (Object.keys(_param).length > 0) {
            const params = new FormData();
            params.append('caseCode', _param.caseCode);
            api.getCaseFileInfo(params, {
                'Content-Type': 'application/x-www-form-urlencoded'
            }).then((res: any) => {
                if (res.code == 0) {
                    let _token: any = {};
                    try {
                        _token = JSON.parse(sessionStorage.getItem('token') || '{}');
                    } catch (error) {
                        _token = {};
                    }
                    let _node = res.data || {};
                    let _task = _node.tasks[0] || [];
                    let __formData = {
                        channel: 'EDC',
                        tenantCode: props.allData.tenantCode,
                        caseCode: props.allData.caseCode,
                        eventCode: _node.code,
                        crfVersion: _task.formVersion,
                        crfCode: _task.formCode,
                        recordCode: _task.code,
                        userCode: _token.userCode
                    };
                    setFormData(__formData);
                }
            });
        }
    }

  /**
    * 表单内容保存成功的回调
    * @param savedData 
    */
    const onSaveSuccess = (savedData: any) => {
        Toast.success('保存成功');
    }

    /**
     * 保存表单内容
     */
     const handleSave = () => {
        CrfRef.current.handleSave()
    }

    return (
        <div className={`${styles.patientHome_basicArchives}`}>
            <div className={styles.crfContent}>
            {
                formData && Object.keys(formData).length > 0 &&
                <CRFComponent
                    ref={CrfRef}
                    params={formData}
                    readonly={true}
                    onSaveSuccess={(v: any) => onSaveSuccess(v)}
                />
            }
            </div>
            {/* <div className={styles.actonBtns}>
                <div className={styles.nextBtn} onClick={handleSave}>
                    保存
                </div>
            </div> */}
        </div>
    )

}

export default InformedArchives;